import React, { useState, useEffect } from "react";

import { useLocation } from "react-router-dom";

import { useFeaturesState } from "contexts/features";
import { useSidebarDispatch, useSidebarState } from "contexts/sidebar";
import { useUserState } from "contexts/user";
import { hasASubAppWithReadPermission } from "utils/roleBasedAccess";

import Sidebar from "./clearsense-ui/layouts/Sidebar";

import { SIDEBAR_LINKS_SETTINGS, SIDEBAR_FOOTER_LINKS } from "../constants";

const SidebarContainer = ({ children }) => {
    const { pathname } = useLocation();
    const features = useFeaturesState();
    const user = useUserState();

    const filterSidebarLinkSettings = () =>
        SIDEBAR_LINKS_SETTINGS.filter(
            (link) => features?.all?.header?.settings?.[link.label]
        );

    const filterSidebarFooterLinks = () =>
        SIDEBAR_FOOTER_LINKS.filter((link) =>
            features?.all?.sidebar_footer?.includes(link.label)
        );

    const getActiveApp = (sidebarDispatch) => {
        const appPath = pathname.split("/")[1];
        switch (appPath) {
            case "management": {
                hasASubAppWithReadPermission(
                    features?.all?.client_apps?.["data_management"],
                    user
                ) &&
                    sidebarDispatch?.({
                        type: "SET_CURRENT_APP",
                        payload: { currentApp: "Data Management" },
                    });
                return {
                    name: "Data Management",
                    links: features?.permissible.management,
                };
            }
            case "ingestion": {
                hasASubAppWithReadPermission(
                    features?.all?.client_apps?.["data_ingestion"],
                    user
                ) &&
                    sidebarDispatch?.({
                        type: "SET_CURRENT_APP",
                        payload: { currentApp: "Data Ingestion" },
                    });
                return {
                    name: "Data Ingestion",
                    links: features?.permissible.ingestion,
                };
            }
            case "consumption": {
                hasASubAppWithReadPermission(
                    features?.all?.client_apps?.["data_consumption"],
                    user
                ) &&
                    sidebarDispatch?.({
                        type: "SET_CURRENT_APP",
                        payload: { currentApp: "Data Consumption" },
                    });

                return {
                    name: "Data Consumption",
                    links: features?.permissible.consumption,
                };
            }
            case "settings": {
                sidebarDispatch?.({
                    type: "SET_CURRENT_APP",
                    payload: { currentApp: "Settings" },
                });
                return { name: "Settings", links: filterSidebarLinkSettings() };
            }
            case "search": {
                return { name: "Search", links: [] };
            }
            default: {
                return { name: "", links: [] };
            }
        }
    };
    const [activeApp, setActiveApp] = useState(getActiveApp());

    const { isExpanded: isSidebarExpanded } = useSidebarState();
    const sidebarDispatch = useSidebarDispatch();
    const toggleSideBar = () => sidebarDispatch({ type: "TOGGLE_SIDEBAR" });

    useEffect(() => {
        setActiveApp(getActiveApp(sidebarDispatch));
    }, [pathname]);

    return (
        <div className="flex flex-1 min-h-0">
            <Sidebar
                isCollapsed={!isSidebarExpanded}
                onCollapse={toggleSideBar}
                organizationInfo={{
                    name: activeApp.name,
                }}
                footerLinks={filterSidebarFooterLinks()}
                navLinks={activeApp.links}
                appName={activeApp.name}
            />
            {children}
        </div>
    );
};

export default SidebarContainer;
